<div class="w100 p15 bg-white">
  <div class="font14 bold html" [innerHTML]="notification.subject"></div>
  @if (text !== notification.subject) {
    <div class="mT15 html" [innerHTML]="text"></div>
  }
  <div class="mT15 df" style="flex-wrap: wrap; justify-content: center">
    <div class="mT15 df" style="flex-wrap: wrap; justify-content: center">
      @if (notification.category !== 'ticket') {
        @for (input of notification.inputs || []; track input) {
          <cs-button (callback)="onClickInputButton(input)" [class]="'m2 primary btn-xxs ' + input.css">
            <cs-button-text>{{ input.text }}</cs-button-text>
          </cs-button>
        }
      }

      @if (notification.openURL) {
        <cs-button (callback)="navigateToURL()" [class]="'m2 primary btn-xxs'">
          <cs-button-text i18n="@@view">View</cs-button-text>
        </cs-button>
      }
    </div>
  </div>
</div>